import styled from "styled-components";
import { ThemeColor } from "../themes and styles/colors";
import { Bold } from "../themes and styles/text_styles";

const PaginationButton = styled.button`
  height: 35px;
  margin: 0 4px 0 0;
  font-ize: 14px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  width: 85px;
  float: left;
  border: 2px solid ${ThemeColor.uke.font.normal};
  border-radius: 35px;
  box-shadow:  0 1px 2px 0 #585858; 
  overflow: hidden;

  &:disabled {
    background: ${ThemeColor.grey.hover};
    box-shadow: inset 2px 2px 4px 2px ${ThemeColor.grey.normal};
    border: 2px solid ${ThemeColor.grey.normal};
  }

  &:disabled:hover {
    background: ${ThemeColor.grey.hover};
  }
  
  &:hover {
    background: ${ThemeColor.uke.blue.lighter};
}
`

const st = {
  height: "35px",
  margin: "0 4px 0 0",
  fontSize: "14px",
  fontWeight: "bold",
  lineHeight: "30px",
  textAlign: "center",
  width: "85px",
  float: "left",
  border: "1px solid #000",
  borderRadius: "35px",
  //boxShadow: "inset 0 1px 2px 0 #585858, inset 0 1px 1px 0 #4E4F53",
  //textShadow: "0 1px 3px #86C4F9",
  overflow: "hidden"
}

function PagingButtons({ prevPage, nextPage, currentPage, totalElements, elementsPerPage }) {
  const numberPages = Math.ceil(totalElements / elementsPerPage);
  return (
    <div>
      <PaginationButton onClick={prevPage} disabled={currentPage === 1}>Prev</PaginationButton>
      <span style={st}>
          <Bold>{currentPage}</Bold>
          &nbsp;of&nbsp;
          <Bold>{numberPages}</Bold>
      </span>
      <PaginationButton onClick={nextPage} disabled={totalElements <= currentPage * elementsPerPage}>Next</PaginationButton>
    </div>
  );
}

export function Pagination({currentPage, setCurrentPage, totalElements, elementsPerPage}) {
  // Function to handle next page click
  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  }

  // Function to handle previous page click
  const prevPage = () => {
    if (currentPage > 1) {
    setCurrentPage(currentPage - 1);

    }
  }

  return (
    <>
      <PagingButtons
        prevPage={prevPage}
        nextPage={nextPage}
        currentPage={currentPage}
        totalElements={totalElements}
        elementsPerPage={elementsPerPage}
      />
    </>
  )
}
